<template>
  <b-modal ref="modal"
           cancel-variant="outline-secondary"
           ok-variant="success"
           @close="onClose"
           no-close-on-backdrop
           title="Choose Client">
    <p>{{ label }}</p>
    <v-form-group :validator="$v.selectedClient" label="Client">
      <v-select v-model="selectedClient" :options="clientOptions" :clearable="false" />
    </v-form-group>
    <template #modal-footer="{ ok, cancel }">
      <b-button v-if="showBackButton" size="md" variant="light" @click="cancel">
        Go Back
      </b-button>
      <b-button size="md" variant="success" @click="submit">
        Submit
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  import { required } from 'vuelidate/lib/validators';

  import adminService from 'services/admin-service';

  import modalFormMixin from 'mixins/modal-form-mixin';

  export default {
    mixins: [modalFormMixin],

    props: {
      label: {
        type: String,
        required: true
      },
      path: {
        type: String,
        required: true
      },
      showBackButton: {
        type: Boolean,
        default: true
      },
      replace: {
        type: Boolean
      }
    },

    data() {
      return {
        selectedClient: null,

        clientOptions: []
      }
    },

    validations: {
      selectedClient: { required }
    },

    methods: {
      async beforeShow() {
        this.clientOptions = (await adminService.getClientsForClientAdmin()).map(c => {
          return {
            label: c.name,
            value: c.id
          }
        }).sort((a, b) => a.label.localeCompare(b.label));
      },

      onSubmit() {
        let route = { path: this.path, query: { id: this.selectedClient.value } };

        if (this.replace) {
          this.$router.replace(route);
        }
        else {
          this.$router.push(route);
        }
      },

      onClose() {
        this.$router.back();
      }
    }
  }
</script>